<div class="logo">
  <a
    href="https://www.clinicadentalruizbusquets.es"
    target="_blank"
    class="simple-text"
  >
    <div class="logo-img">
      <img src="/assets/img/logo.png" />
    </div>
  </a>
</div>
<div class="sidebar-wrapper">
  <div class="nav-label">{{ 'nav.label' | translate }}</div>
  <ul class="nav">
    @for (menuItem of menuItems; track menuItem) {
      <li routerLinkActive="active" class="{{ menuItem.class }} nav-item">
        <a class="nav-link" [routerLink]="[menuItem.path]">
          <i class="material-icons">{{ menuItem.icon }}</i>
          <p>{{ menuItem.title | translate }}</p>
        </a>
      </li>
    }
  </ul>
  <div class="sidebar-footer">
    <span class="footer-chip">v{{ appVersion }}</span>
  </div>
</div>
